import React, { useEffect } from 'react';
import CustomHead from '@/components/Common/Layout/Head';
import { Layout } from '@/components/Common';
import { NextPageWithLayout } from '@/pages/_app';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import { STATIC_FILE_URL, WEBSITE_URL } from '@/shared/constants';
import { logPageView } from '@/lib/service';
import ExistingBrandsLandingPage from '@/components/ExistingBrandsLandingPage';

const ExistingBrands = ({}: NextPageWithLayout<any>) => {
  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: 'Scale Your Brand With Pietra',
    });
  }, []);
  return <ExistingBrandsLandingPage />;
};

ExistingBrands.getLayout = (page: React.ReactElement) => {
  const invisibleHeaderTags = (
    <div style={{ display: 'none' }}>
      <h1>Pietra is everything your brand needs to scale.</h1>
      <h2>Explore a Pietra Membership to save your brand time and money.</h2>
      <h2>Access to cutting edge visualization and market research tools.</h2>
      <h2>Sourcing tools for growing e-commerce brands.</h2>
      <h2>A private 3PL, available only to members.</h2>
      <h2>Access apps and sales channels to help grow revenue.</h2>
    </div>
  );

  return (
    <>
      <CustomHead
        title="Save big & grow your brand | Pietra"
        description="Members-only factories, fulfillment services, marketing tools, and more — an average savings of 30-50%."
        url={`${WEBSITE_URL}/existing-brands`}
        image={`${STATIC_FILE_URL}/979cfc6803ccc39ed1d7d9c198c2e72c.png`}
      />
      <Layout structured={SEO_META[SEO_META_PAGES.EXISTING_BRANDS].jsonld({})}>
        {invisibleHeaderTags}
        {page}
      </Layout>
    </>
  );
};
export default ExistingBrands;
